var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4841 6.04691H19.8279V3.51566C19.8279 1.57714 18.2508 3.05176e-05 16.3123 3.05176e-05H7.68726C5.74874 3.05176e-05 4.17163 1.57714 4.17163 3.51566V6.04691H3.51538C1.57687 6.04691 -0.000244141 7.62401 -0.000244141 9.56253V15.1875C-0.000244141 17.126 1.57687 18.7032 3.51538 18.7032H4.17163V21.8907C4.17163 23.0538 5.1179 24 6.28101 24H17.7185C18.8816 24 19.8279 23.0538 19.8279 21.8907V18.7032H20.4841C22.4226 18.7032 23.9998 17.126 23.9998 15.1875V9.56253C23.9998 7.62401 22.4226 6.04691 20.4841 6.04691ZM5.57788 3.51566C5.57788 2.35255 6.52415 1.40628 7.68726 1.40628H16.3123C17.4754 1.40628 18.4216 2.35255 18.4216 3.51566V6.04691H5.57788V3.51566ZM18.4216 21.8907C18.4216 22.2784 18.1062 22.5938 17.7185 22.5938H6.28101C5.8933 22.5938 5.57788 22.2784 5.57788 21.8907V14.9532H18.4216V21.8907ZM22.5935 15.1875C22.5935 16.3506 21.6472 17.2969 20.4841 17.2969H19.8279V14.9532H20.2498C20.6381 14.9532 20.9529 14.6383 20.9529 14.25C20.9529 13.8617 20.6381 13.5469 20.2498 13.5469H3.74976C3.36144 13.5469 3.04663 13.8617 3.04663 14.25C3.04663 14.6383 3.36144 14.9532 3.74976 14.9532H4.17163V17.2969H3.51538C2.35227 17.2969 1.40601 16.3506 1.40601 15.1875V9.56253C1.40601 8.39942 2.35227 7.45316 3.51538 7.45316H20.4841C21.6472 7.45316 22.5935 8.39942 22.5935 9.56253V15.1875Z",
    fill: "#95A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8748 16.5469H10.1248C9.73644 16.5469 9.42163 16.8617 9.42163 17.25C9.42163 17.6383 9.73644 17.9532 10.1248 17.9532H13.8748C14.2631 17.9532 14.5779 17.6383 14.5779 17.25C14.5779 16.8617 14.2631 16.5469 13.8748 16.5469Z",
    fill: "#95A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8748 19.5469H10.1248C9.73644 19.5469 9.42163 19.8617 9.42163 20.25C9.42163 20.6383 9.73644 20.9532 10.1248 20.9532H13.8748C14.2631 20.9532 14.5779 20.6383 14.5779 20.25C14.5779 19.8617 14.2631 19.5469 13.8748 19.5469Z",
    fill: "#95A3B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.ab15afbe8e78085fdb1f36bc47549952.svg";
export { ForwardRef as ReactComponent };